import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Zoom from "@mui/material/Zoom";
import { useStyles } from "./Styles";
import { FaChevronUp } from "react-icons/fa";

const propTypes = {
  window: () => Window,
  children: React.createElement,
};

ScrollToTop.prototype = propTypes;
function ScrollTop(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 64, right: 12, zIndex: 10000 }}
      >
        {props.children}
      </Box>
    </Zoom>
  );
}

export default function ScrollToTop(props) {
  const styles = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <div id="back-to-top-anchor" />
      {props.children}
      <ScrollTop {...props}>
        <Fab className={styles.scrollBtn} aria-label="scroll to top">
          <FaChevronUp />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
}
